module.exports = function (e) {
  var t = {};
  function r(n) {
    if (t[n]) return t[n].exports;
    var a = t[n] = {
      i: n,
      l: !1,
      exports: {}
    };
    return e[n].call(a.exports, a, a.exports, r), a.l = !0, a.exports;
  }
  return r.m = e, r.c = t, r.d = function (e, t, n) {
    r.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: n
    });
  }, r.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, r.t = function (e, t) {
    if (1 & t && (e = r(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var n = Object.create(null);
    if (r.r(n), Object.defineProperty(n, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var a in e) r.d(n, a, function (t) {
      return e[t];
    }.bind(null, a));
    return n;
  }, r.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return r.d(t, "a", t), t;
  }, r.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, r.p = "", r(r.s = 1);
}([function (e, t) {
  e.exports = require("react");
}, function (e, t, r) {
  "use strict";

  r.r(t);
  var n = r(0),
    a = r.n(n);
  function o(e) {
    var t = e.children,
      r = e.label,
      n = e.showLabel,
      o = e.name;
    return n ? a.a.createElement("label", {
      "data-label": o
    }, a.a.createElement("span", null, r), t) : t;
  }
  var u = function (e) {
    var t = e.items,
      r = e.value,
      n = e.label,
      u = e.showLabel,
      l = e.name,
      i = e.onChange,
      c = e.renderOption,
      f = e.generateValue;
    return a.a.createElement(o, {
      label: n,
      showLabel: u,
      name: l
    }, a.a.createElement("select", {
      value: r,
      onChange: i,
      "data-field": l
    }, a.a.createElement("option", {
      disabled: !0,
      value: ""
    }, n), t.map(function (e, t) {
      return a.a.createElement("option", {
        key: e,
        value: f ? f(e, t) : e
      }, c ? c(e, t) : e);
    })));
  };
  function l(e, t) {
    for (var r = [], n = e; n <= t; n += 1) r.push(n);
    return r;
  }
  function i(e) {
    return e ? {
      day: e.getDate(),
      month: e.getMonth(),
      year: e.getFullYear()
    } : {
      day: "",
      month: "",
      year: ""
    };
  }
  function c(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function f(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = r, e;
  }
  function s(e, t) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, t) {
      if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e))) return;
      var r = [],
        n = !0,
        a = !1,
        o = void 0;
      try {
        for (var u, l = e[Symbol.iterator](); !(n = (u = l.next()).done) && (r.push(u.value), !t || r.length !== t); n = !0);
      } catch (e) {
        a = !0, o = e;
      } finally {
        try {
          n || null == l.return || l.return();
        } finally {
          if (a) throw o;
        }
      }
      return r;
    }(e, t) || function (e, t) {
      if (!e) return;
      if ("string" == typeof e) return b(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      "Object" === r && e.constructor && (r = e.constructor.name);
      if ("Map" === r || "Set" === r) return Array.from(r);
      if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return b(e, t);
    }(e, t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }
  function b(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
    return n;
  }
  t.default = function (e) {
    var t = e.value,
      r = e.minDate,
      o = e.maxDate,
      b = e.className,
      m = e.css,
      y = e.onDateChange,
      d = e.showErrors,
      p = void 0 === d || d,
      v = e.showLabels,
      O = void 0 === v || v,
      h = e.yearLabel,
      g = void 0 === h ? "Year" : h,
      j = e.monthLabel,
      M = void 0 === j ? "Month" : j,
      w = e.dayLabel,
      D = void 0 === w ? "Day" : w,
      I = e.errorFormat,
      A = void 0 === I ? "Invalid date" : I,
      S = e.errorMin,
      E = void 0 === S ? "Date must be greater than allowed" : S,
      L = e.errorMax,
      P = void 0 === L ? "Date must be less than allowed" : L,
      N = e.format,
      _ = void 0 === N ? "month/day/year" : N,
      x = e.monthNames,
      F = void 0 === x ? ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"] : x,
      T = Object(n.useMemo)(function () {
        return i(t);
      }, [t]),
      V = Object(n.useMemo)(function () {
        return r || new Date(1900, 0, 1);
      }, [r]),
      C = Object(n.useMemo)(function () {
        return o || new Date();
      }, [o]),
      Y = Object(n.useMemo)(function () {
        return V.getFullYear();
      }, [V]),
      k = Object(n.useMemo)(function () {
        return C.getFullYear();
      }, [C]),
      J = Object(n.useMemo)(function () {
        return _.split("/");
      }, [_]),
      R = Object(n.useMemo)(function () {
        return l(Y, k);
      }, [Y, k]),
      X = Object(n.useMemo)(function () {
        return l(1, 31);
      }, []),
      q = Object(n.useMemo)(function () {
        return {
          INVALID_FORMAT: A,
          INVALID_MIN: E,
          INVALID_MAX: P
        };
      }, [A, E, P]),
      U = s(Object(n.useState)(T), 2),
      $ = U[0],
      z = U[1],
      B = s(Object(n.useState)(null), 2),
      G = B[0],
      H = B[1];
    Object(n.useEffect)(function () {
      t ? z(i(t)) : "" === t && z(i(null));
    }, [t]);
    var K = Object(n.useCallback)(function (e) {
        var t,
          r,
          n,
          a,
          o = parseInt(e.target.value, 10),
          u = e.target.dataset.field,
          l = function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var r = null != arguments[t] ? arguments[t] : {};
              t % 2 ? c(Object(r), !0).forEach(function (t) {
                f(e, t, r[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : c(Object(r)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
              });
            }
            return e;
          }({}, $, f({}, u, o)),
          i = (t = l.year, r = l.month, n = l.day, (a = new Date()).setFullYear(t, r, n), a.getFullYear() === t && a.getMonth() === r && a.getDate() === n) ? new Date(l.year, l.month, l.day) : null,
          s = null;
        i ? i.getTime() > C.getTime() ? s = "INVALID_MAX" : i.getTime() < V.getTime() && (s = "INVALID_MIN") : l.year && l.month && l.day && (s = "INVALID_FORMAT"), z(l), y(i), H(s);
      }, [$, y, C, V]),
      Q = Object(n.useMemo)(function () {
        return {
          day: D,
          month: M,
          year: g
        };
      }, [D, M, g]),
      W = Object(n.useMemo)(function () {
        return {
          day: X,
          month: F,
          year: R
        };
      }, [X, F, R]),
      Z = Object(n.useMemo)(function () {
        return [b, G ? "has-error" : null].join(" ").trim() || null;
      }, [b, G]);
    return a.a.createElement("div", {
      className: Z,
      css: m
    }, a.a.createElement("div", null, J.map(function (e) {
      return a.a.createElement(u, {
        key: e,
        items: W[e],
        label: Q[e],
        showLabel: O,
        value: $[e],
        onChange: K,
        name: e,
        renderOption: "day" === e ? function (e) {
          return function (e) {
            return String(e).padStart(2, "0");
          }(e);
        } : null,
        generateValue: "month" === e ? function (e, t) {
          return t;
        } : null
      });
    })), G && p && a.a.createElement("p", null, q[G]));
  };
}]);